import AccessoryProductCard from './AccessoryProductCard';

export default function AccessoryProductGrid({ products }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {products.map((product) => (
                <AccessoryProductCard key={product.id} product={product} />
            ))}
        </div>
    );
}
